import { enhancer as photoSwipeEnhancer } from "./photoswipe";

export const enhancer = (el) => {
  photoSwipeEnhancer(el);
};
